export default {
  namespaced: true,
  state() {
    return {
      cart: null,
      search: null,
    }
  },
  mutations: {
    setCart(state, value) {
      state.cart = value
    },
    setSearch(state, value) {
      state.search = value
    },
  },
  actions: {
    cart({ commit }, form) {
      commit('setCart', form)
    },
    search({ commit }, form) {
      commit('setSearch', form)
    },
  },
  getters: {
    cart(state) {
      return state.cart
    },
    search(state) {
      return state.search
    },
  }
}